import * as Yup from 'yup';
import { encuestaFormModel } from './encuestaFormModel';

const {
    formField: { name, description, type, areas_rating_id, questions, questionText }
} = encuestaFormModel;

export const validationSchema = Yup.object().shape({
    [name.name]: Yup.string().required(name.requiredErrorMsg),
    [description.name]: Yup.string().required(description.requiredErrorMsg),
    [type.name]: Yup.object().nullable().required(type.requiredErrorMsg),
    [areas_rating_id.name]: Yup.object().nullable().required(areas_rating_id.requiredErrorMsg),
    [questions.name]: Yup.array().of(
        Yup.object().shape({
            [questionText.name]: Yup.string().required(questionText.requiredErrorMsg),
        })
    ).min(1, questions.requiredErrorMsg)
});
